import { getSuiteHeaderTheme } from '@ms/yammer-data/dist/domains/suiteHeaderTheme/selectors';

import { useSelector } from '../useSelector';

type UseSuiteHeaderTheme = () => ReturnType<typeof getSuiteHeaderTheme>;
export const useSuiteHeaderTheme: UseSuiteHeaderTheme = () => useSelector(getSuiteHeaderTheme);

type UseIsDefaultTheme = () => boolean;
export const useIsDefaultTheme: UseIsDefaultTheme = () => useSuiteHeaderTheme().isDefault;
